module.exports = __webpack_public_path__ + "img/bg30.e3a3f15b.png";